import type { KeyboardEvent } from 'react';

type Result = ModelHookResult<
	{
		borderBackgroundClass: string;
		backgroundClass: string;
	},
	{
		handleKeyDown: (event: KeyboardEvent<HTMLDivElement>) => void;
	}
>;

const SELECTION_CARD_STYLES = {
	checked: {
		borderBackgroundClass: 'bg-gradient-fill-progress',
		backgroundClass: 'bg-fill-accent-primary-weaker',
	},
	unchecked: {
		borderBackgroundClass: '',
		backgroundClass: 'bg-fill-inverse-strong',
	},
} as const;

export function useSelectionCard(checked: boolean, onSelect: () => void): Result {
	return {
		data: checked ? SELECTION_CARD_STYLES.checked : SELECTION_CARD_STYLES.unchecked,
		actions: {
			handleKeyDown: (event: KeyboardEvent<HTMLDivElement>): void => {
				if (event.key === ' ' || event.key === 'Enter') {
					event.preventDefault();
					onSelect();
				}
			},
		},
	};
}
